import type {ReactElement} from 'react';
import React from 'react';
import {ScrollablePills} from '@Components/scrollable-pills';
import {ImageAndVideoRecorderStatus, RecorderMediaType} from '@Panels/record-image-and-video-panel/record-image-and-video.types';
import {setMediaType} from '@Panels/record-image-and-video-panel/record-image-and-video-panel-reducer';
import {useAppDispatch, useAppSelector} from '@/hooks';
import styles from './image-and-video-toggle-mobile.module.scss';

interface ImageAndVideoToggleMobileProps {
  className?: string;
}

export function ImageAndVideoToggleMobile({className = ''}: ImageAndVideoToggleMobileProps): ReactElement | null {
  const dispatch = useAppDispatch();

  const mediaType = useAppSelector((state) => {
    return state.recordImageAndVideoPanel.mediaType;
  });

  const recorderStatus = useAppSelector((state) => {
    return state.recordImageAndVideoPanel.imageAndVideoRecorderStatus;
  });

  return (
    <div className={`_full-width flex-center ${className} ${styles.mobileImageAndVideoToggleWrapper}`}>
      <ScrollablePills
        disabled={recorderStatus === ImageAndVideoRecorderStatus.RECORDING}
        noBackground
        className="_full-width"
        data={[
          {
            id: RecorderMediaType.IMAGE,
            text: window.i18next.t('pmwjs_image'),
          },
          {
            id: RecorderMediaType.VIDEO,
            text: window.i18next.t('pmwjs_video'),
          },
        ]}
        selectedItemId={mediaType}
        onClick={() => {
          if (mediaType === RecorderMediaType.IMAGE) {
            dispatch(setMediaType({mediaType: RecorderMediaType.VIDEO}));
          } else if (mediaType === RecorderMediaType.VIDEO) {
            dispatch(setMediaType({mediaType: RecorderMediaType.IMAGE}));
          }
        }}
      />
    </div>
  );
}
